import React, {useEffect} from 'react';
import './App.css';
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import {getAnalytics} from "firebase/analytics";
import {AuthProvider} from "./utils/AuthProvider";
import '@fontsource/inter';
import {Box, CssBaseline, CssVarsProvider, extendTheme} from "@mui/joy";
import {Router} from "./utils/Router";
import {FeedbackProvider} from "./utils/FeedbackContext";
import "./utils/i18n";

if (!firebase.apps.length) {
    const app = firebase.initializeApp({
        apiKey: "AIzaSyAGgHFzcmNMPSItG5PyGNHVYac1D3wJ-e0",
        authDomain: "cinefxapp.firebaseapp.com",
        projectId: "cinefxapp",
        storageBucket: "cinefxapp.firebasestorage.app",
        messagingSenderId: "291918352599",
        appId: "1:291918352599:web:b2b69b77a900295382e092",
        measurementId: "G-Z9V0RX0C48"
    })
    getAnalytics(app);
}

const baseTheme = extendTheme();
const darkOnlyTheme = extendTheme({
    cssVarPrefix: "sidebar_",
    colorSchemes: {
        light: baseTheme.colorSchemes.dark,
        dark: baseTheme.colorSchemes.dark,
    },
});

function App() {

    useEffect(() => {
        console.info('\x1b[34m%s\x1b[0m', // \x1b[38;5;33m
            "\n\n" +
            "         Developed with <3 by\n" +
            "         DANIELE DI GREGORIO\n" +
            "      cinefx.danieledigregorio.it\n")
    }, []);

    return (
        <div>
            {/* FeedbackProvider fuori da AuthProvider: quest'ultimo deve
                poter mostrare errori (FeedbackContext) durante lo scambio
                del login_code SSO — vedi AuthProvider.tsx. */}
            <FeedbackProvider>
                <AuthProvider>
                    <CssVarsProvider theme={darkOnlyTheme} defaultMode="light">
                        <CssBaseline />
                        {/* Stessi 4 punti (viola/blu/ciano/viola) dello sfondo
                            animato dell'app Flutter, versione statica: stesso
                            mood senza il costo di un'animazione continua sul
                            web. */}
                        <Box sx={{
                            minHeight: '100%',
                            maxWidth: '100vw',
                            backgroundColor: "#000",
                            backgroundImage: `
                                radial-gradient(circle at 15% 10%, rgba(175,82,222,0.16) 0%, transparent 35%),
                                radial-gradient(circle at 85% 15%, rgba(0,122,255,0.14) 0%, transparent 35%),
                                radial-gradient(circle at 15% 90%, rgba(50,173,230,0.12) 0%, transparent 35%),
                                radial-gradient(circle at 90% 85%, rgba(175,82,222,0.10) 0%, transparent 35%)
                            `,
                            backgroundAttachment: {xs: "scroll", md: "fixed"},
                            backgroundRepeat: "no-repeat",
                        }}
                        >
                            <Router />
                        </Box>
                    </CssVarsProvider>
                </AuthProvider>
            </FeedbackProvider>
        </div>
    );
}

export default App;
